import type { TimelapseExportState } from "../types";

export function subtitleForState(state: TimelapseExportState, hasDownloadedReadyVideo: boolean): string {
  switch (state.kind) {
    case "idle":
      return "Past 7 days";
    case "requesting":
      return "Requesting…";
    case "queued":
      return "Queued";
    case "processing":
      return "Rendering…";
    case "ready":
      return hasDownloadedReadyVideo ? "Downloaded" : "Ready to download";
    case "failed":
      return "Retry export";
  }
}
